import { useState } from 'react';
import FlexPane from 'presentation/components/flex-pane/index.js';
import ImageButton from 'presentation/components/image-button/index.js';
import Tooltip from 'presentation/components/tooltip/index.js';

const NeutralVenueIndicator = props => {
    const {
        mojitoTools: { config, stringResolver },
    } = props;

    const { shouldShowTooltip, container, icon, tooltip } = config;
    const tooltipText = stringResolver.resolveString('$NEUTRAL_VENUE_INDICATOR.TOOLTIP_TEXT');
    const [showTooltip, setShowTooltip] = useState(false);

    const toggleTooltip = () => {
        setShowTooltip(!showTooltip);
    };

    return (
        <FlexPane
            class="ta-NeutralVenueIndicator"
            onMouseLeave={toggleTooltip}
            onMouseEnter={toggleTooltip}
            config={container}
        >
            <ImageButton onClick={toggleTooltip} config={icon} />
            {shouldShowTooltip && showTooltip && (
                <Tooltip text={tooltipText} onClose={toggleTooltip} config={tooltip} />
            )}
        </FlexPane>
    );
};
export default NeutralVenueIndicator;
